export default "__VITE_ASSET__CGE2lxMJ__"